<template>
  <div v-show="attentionList.length" class="recommend-focus">
    <div v-if="hasAttention" class="attention-top">
      <span class="attention-title">已关注的品牌</span>
      <a v-if="hasMore" href="#"><span class="more" @click="_toAttentionList">更多<i class="icon" /></span></a>
    </div>
    <div v-else class="attention-top">
      <span class="attention-title">推荐品牌</span>
    </div>
    <div class="swiper-container attention-box">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in attentionList.slice(0,10)" :key="index" class="swiper-slide attention-item">
          <div @click="_tobrandIndex(item.brandId)">
            <div class="log-box">
              <img :src="item.brandLogo" alt="" class="logo">
            </div>
            <div class="brand-name">{{ item.brandName }}</div>
          </div>
          <div v-if="!hasAttention">
            <div v-if="!item.success" class="attention-btn orange" @click="_toAttention(index)"><span class="icon">+</span>关注</div>
            <div v-else class="attention-btn gray" @click="_toAttention(index)">已关注</div>
          </div>
        </div>
        <div v-if="hasAttention && hasMore" class="swiper-slide attention-item" @click="_toAttentionList">
          <a href="#" class="look-more">
            <div class="more-img" />
            <div class="txt">查看更多</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Swiper from 'swiper';
import { Toast } from 'vant';
import nativeBrandIndex from '../filters/nativeBrandIndex';
import { isApp, isAndroid } from '@/lib/compatibility';


Vue.use(Toast);

export default {
  name: 'RecommendFocus',
  props: {
    hasAttention: {
      type: Boolean,
      default: false,
    },
    hasMore: {
      type: Boolean,
      default: false,
    }, // 是否有超过10个关注品牌
    brandViews: {
      type: Array,
      default: () => [],
    },
    tjjjPrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      attentionList: [],
    };
  },
  watch: {
    brandViews(val) {
      if (val) {
        this.attentionList = [];
        this.$nextTick(() => {
          this.attentionList = val;
        });
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
  },
  methods: {
    _initData() {
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper('.attention-box', {
        freeMode: true,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        slidesPerView: 2.4,
        spaceBetween: 10,
        on: {
          touchStart() {
            if (isApp && isAndroid) Touch.requestEvent(true);
          },
          touchEnd() {
            if (isApp && isAndroid) Touch.requestEvent(false);
          },
        },
      });
    },
    _toAttentionList() {
      window.location.href = `${globalRootUrl}ppzq/ppgz/`;
    },
    _toAttention(index) {
      this.$emit('toggle-attention', index);
    },
    _tobrandIndex(brandId) {
      window.location.href = nativeBrandIndex(`${globalRootUrl}ppzq/brand-${brandId}/`);
    },
  },
};
</script>

<style scoped lang="less">
@import "../style/common.less";
@import "../style/swiper.min.css";

.recommend-focus {
  padding-top: 50px;
  margin: 0 28px;

  .attention-top {
    display: flex;
    flex-flow: nowrap;
    align-items: center;
    height: 40px;

    .attention-title {
      font-size: 36px;
      font-weight: bold;
      color: #121529;
      line-height: 40px;
      flex: 1;
    }

    .more {
      margin: 0;
      color: #848494;
      font-size: 24px;
      line-height: 34px;
      position: relative;
      font-weight: 400 !important;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;

      .icon {
        width: 10px;
        margin-left: 13px;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          margin-top: -6px;
          border-top: 4px solid #848494;
          border-right: 4px solid #848494;
          width: 7px;
          height: 7px;
          border-radius: 2px;
          transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        }
      }
    }
  }

  .attention-box {
    margin-top: 40px;

    .attention-item {
      width: 260px !important;
      border: 1PX solid #ecebeb;
      border-radius: 10px;
      text-align: center;
      margin-right: 30px !important;

      .log-box {
        width: 100%;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
          width: 165px;
          height: 90px;
          object-fit: contain;
        }
      }

      .brand-name {
        font-size: 32px;
        color: #333;
        line-height: 90px;
        border-top: 1px solid #ecebeb;
        margin: 0 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .attention-btn {
        width: 132px;
        height: 52px;
        line-height: 52px;
        border-radius: 26px;
        font-size: 28px;
        margin: 0 auto 40px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        box-sizing: border-box;
        // align-content: center;

        &.orange {
          border: 1PX solid rgba(238, 45, 27, 0.5);
          background: #fef4f3;
          color: #ee2d1b;

          .icon {
            font-size: 34px;
            font-weight: bold;
            border-radius: 2px;
            margin-right: 5px;
          }
        }

        &.gray {
          border: 1PX solid #e0e0e0;
          background: #fafafa;
          color: #999;
        }
      }
    }

    .look-more {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;
      height: 240px;

      .more-img {
        width: 44px;
        height: 44px;
        background: url('../images/more-img.png') no-repeat center;
        background-size: 100% auto;
        padding-bottom: 23px;
      }

      .txt {
        font-size: 24px;
        color: #848494;
      }
    }
  }
}
</style>
